import config from '@/../config';
import axios from 'axios';

const baseUrl = `http://${process.env.API}:${process.env.API_PORT}`;

axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';


/**
 * Get method.
 * @param path
 * @returns {AxiosPromise}
 */
export function get(path) {
  return axios({
    method: 'GET',
    url: baseUrl + path
  })
}

/**
 * Delete method.
 * @param path
 * @returns {AxiosPromise}
 */
export function del(path) {
  return axios({
    method: 'DELETE',
    url: baseUrl + path
  })
}

/**
 * Put method.
 * @param path
 * @param data
 * @returns {AxiosPromise}
 */
export function put(path, data) {
  return axios({
    method: 'PUT',
    url: baseUrl + path,
    data
  });
}

/**
 * Post method.
 * @param path
 * @param data
 * @returns {AxiosPromise}
 */
export function post(path, data) {
  return axios({
    method: 'POST',
    url: baseUrl + path,
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/web.js